"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var url_transformers_1 = require("url-transformers");

var helpers_1 = require("./helpers");

var maybe_1 = require("./helpers/maybe");

var pipe_1 = require("./helpers/pipe"); // https://docs.imgix.com/apis/url/size/fit


var ImgixFit;

(function (ImgixFit) {
  ImgixFit["clamp"] = "clamp";
  ImgixFit["clip"] = "clip";
  ImgixFit["crop"] = "crop";
  ImgixFit["facearea"] = "facearea";
  ImgixFit["fill"] = "fill";
  ImgixFit["fillmax"] = "fillmax";
  ImgixFit["max"] = "max";
  ImgixFit["min"] = "min";
  ImgixFit["scale"] = "scale";
})(ImgixFit = exports.ImgixFit || (exports.ImgixFit = {})); // https://docs.imgix.com/apis/url/format/cs


var ImgixColorSpace;

(function (ImgixColorSpace) {
  ImgixColorSpace["srgb"] = "srgb";
  ImgixColorSpace["adobergb1998"] = "adobergb1998";
  ImgixColorSpace["tinysrgb"] = "tinysrgb";
  ImgixColorSpace["strip"] = "strip";
})(ImgixColorSpace = exports.ImgixColorSpace || (exports.ImgixColorSpace = {}));

var pickTrueInObject = function pickTrueInObject(obj) {
  return helpers_1.pickBy(obj, function (_key, value) {
    return value;
  });
};

var pickTrueObjectKeys = pipe_1.pipe(pickTrueInObject, // tslint:disable-next-line no-unbound-method
Object.keys);

var undefinedIfEmptyString = function undefinedIfEmptyString(str) {
  return str === '' ? undefined : str;
};

var joinWithComma = function joinWithComma(strs) {
  return strs.join(',');
};

var serializeImgixUrlQueryParamListValue = pipe_1.pipe(pickTrueObjectKeys, joinWithComma, undefinedIfEmptyString);
var mapToSerializedListValueIfDefined = maybe_1.mapValueIfDefined(serializeImgixUrlQueryParamListValue);

var serializeImgixUrlQueryParamValues = function serializeImgixUrlQueryParamValues(query) {
  return pipe_1.pipe(function () {
    return {
      ar: maybe_1.mapValueIfDefined(function (ar) {
        return ar.w + ":" + ar.h;
      })(query.ar),
      dpr: query.dpr,
      auto: mapToSerializedListValueIfDefined(query.auto),
      fit: query.fit,
      w: query.w,
      h: query.h,
      q: query.q,
      cs: query.cs,
      crop: mapToSerializedListValueIfDefined(query.crop),
      bg: query.bg,
      ch: mapToSerializedListValueIfDefined(query.ch),
      blur: query.blur,
      faceindex: query.faceindex,
      facepad: query.facepad
    };
  }, maybe_1.catMaybesDictionary)({});
};

exports.buildImgixUrl = function (url) {
  return pipe_1.pipe(serializeImgixUrlQueryParamValues, function (query) {
    return url_transformers_1.addQueryToUrl({
      url: url
    })({
      queryToAppend: query
    });
  });
};